module.exports = __webpack_public_path__ + "img/LV15.938a9f23.png";